import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


import PrivateUserRoute from '../components/user/private_route'; //rota privada do adm
import LoginUserScreen from '../screens/login'; //tela de login do RH
import AdmLoggedScreen from '../screens/user/home'; // tela logada do RH
import HomeScreen from '../screens/home'; // home page pública
import SolicitarScreen from '../screens/solicitar'; // cadastrar solicitação pública
import ConsultarSolicScreen from '../screens/consultar'; // consultar solicitação pública

//rotas de solicitações
import SolicitacaoScreen from '../screens/user/solicitacao'; //CRUD de solicitações
import ListSolicitacaoPendScreen from '../screens/user/solicitacao/pendentes'; //CRUD de solicitações
import ListSolicitacaoRespScreen from '../screens/user/solicitacao/respondidas'; //CRUD de solicitações
import VerComponentesSolicitacaoScreen from '../screens/user/solicitacao/componentes'; //Ver componentes da solicitação
import EditSolicitacaoScreen from '../screens/user/solicitacao/editar'; //CRUD de solicitações
//fim rotas solicitações

//rotas de componentes
import ComponentesScreen from '../screens/user/componentes'; //CRUD de componentes
import ListComponentesScreen from '../screens/user/componentes/listar'; //CRUD de componentes
import CadComponentesScreen from '../screens/user/componentes/cadastrar'; //CRUD de componentes
import ImportComponentesScreen from '../screens/user/componentes/importar'; //Importar componentes
import EditComponentesScreen from '../screens/user/componentes/editar'; //CRUD de componentes
//fim rotas componentes

//rotas de usuários
import UserScreen from '../screens/user/user'; //CRUD de usuários do sistema
import ListUserScreen from '../screens/user/user/listar'; //CRUD de user
import CadUserScreen from '../screens/user/user/cadastrar'; //CRUD de user
import EditUserScreen from '../screens/user/user/editar'; //CRUD de user
import EditSenhaUserScreen from '../screens/user/user/senha'; //Troca senha de user
//fim rotas usuários


const Rotas = () => {
    return (
        <BrowserRouter basename='/especificacoes'>
            <Routes>
                <Route exact path="/" element={<HomeScreen />} />
                <Route exact path="/login" element={<LoginUserScreen />} />
                <Route exact path="/cadastrar" element={<SolicitarScreen />} />
                <Route exact path="/consultar" element={<ConsultarSolicScreen />} />
                
                
                {/*rotas PRIVADAS*/}
                <Route exact path="/ti" element={<PrivateUserRoute />}>
                    <Route exact path="/ti" element={<AdmLoggedScreen />} />

                    {/* rotas de CRUD componentes */}
                    <Route exact path="/ti/componentes" element={<ComponentesScreen />} />
                    <Route exact path="/ti/componentes/listar" element={<ListComponentesScreen />} />
                    <Route exact path="/ti/componentes/cadastrar" element={<CadComponentesScreen />} />
                    <Route exact path="/ti/componentes/importar" element={<ImportComponentesScreen />} />
                    <Route exact path="/ti/componentes/editar/:id" element={<EditComponentesScreen />} />
                    {/* fim de CRUD*/}

                    {/* rotas de CRUD solicitações */}
                    <Route exact path="/ti/solicitacao" element={<SolicitacaoScreen />} />
                    <Route exact path="/ti/solicitacao/pendentes" element={<ListSolicitacaoPendScreen />} />
                    <Route exact path="/ti/solicitacao/respondidas" element={<ListSolicitacaoRespScreen />} />
                    <Route exact path="/ti/solicitacao/:id/componentes" element={<VerComponentesSolicitacaoScreen />} />
                    <Route exact path="/ti/solicitacao/editar/:id" element={<EditSolicitacaoScreen />} />
                    {/* fim de CRUD*/}

                    {/* rotas de CRUD user */}
                    <Route exact path="/ti/user" element={<UserScreen />} />
                    <Route exact path="/ti/user/listar" element={<ListUserScreen />} />
                    <Route exact path="/ti/user/cadastrar" element={<CadUserScreen />} />
                    <Route exact path="/ti/user/editar/:id" element={<EditUserScreen />} />
                    <Route exact path="/ti/user/senha/:id" element={<EditSenhaUserScreen />} />
                    {/* fim de CRUD*/}
                </Route>
                {/*fim rotas PRIVADAS*/}

            </Routes>
        </BrowserRouter>
    )
}

export default Rotas;